import Vue from "vue";
import Router from "vue-router";
const login = () => import("./views/login.vue");//公众号登录
const appointment = () => import("./views/appointment");//景点报名
const orderCenter = () => import("./views/orderCenter");//订单列表
const activity = () => import("./views/activity");//活动报名
const List = () => import("./views/List");//活动列表
const rSuccess = () => import("./views/rSuccess");//展馆介绍
const pavilion = () => import("./views/pavilion");//介绍详情
const pavilionList = () => import("./views/pavilionList");//线上展馆
const introduce = () => import("./views/introduce");//线上展馆

import { getToken } from "./token";
Vue.use(Router);
//没有token时也不跳转的页面，'orderCenter', 'appointment'会嵌入小程序中所以不容许跳转
let wxlist = ['login']

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/appointment/:id",
      name: "appointment",
      component: appointment
    },
    {
      path: "/orderCenter",
      name: "orderCenter",
      component: orderCenter
    },
    {
      path: "/List/:id",
      name: "List",
      component: List
    },
    {
      path: "/activity/:id",
      name: "activity",
      component: activity
    },
    {
      path: "/pavilion/:id",
      name: "pavilion",
      component: pavilion
    },
    {
      path: "/rSuccess",
      name: "rSuccess",
      component: rSuccess
    },
    {
      path: "/pavilionList",
      name: "pavilionList",
      component: pavilionList
    },
    {
      path: "/introduce/:id",
      name: "introduce",
      component: introduce
    }
    

  ]
});
router.beforeEach((to, from, next) => {
  if (wxlist.lastIndexOf(to.name) == -1) {
    if (getToken()) {
      next()
    } else {
      next("/login?redirect=" + to.path)
    }
  } else {
    next()
  }
})
export default router;